<template>
  <div>
    <a-card>
      <!--&&!noCgAnnounce-->
      <div v-if="!noContractFiling&&!noResultAnnounce">
        <span>贵单位在以下包组中成交，请扫描上传与采购人的合同进行备案</span>
        <span v-if="isPayVisible">，合同备案审查通过后予以退还投标保证金</span>
        <a-table ref="table" :columns="columns" :data-source="loadData" :rowKey="record => record.id"
                 :pagination="false" :loading="tableLoading">
          <template slot="operationSlot" slot-scope="text, record, index">
            <div class="color-red">请将合同扫描为PDF格式文件上传</div>
            <div v-if="record.bidContractFiling">
              <pre-case-upload-selector ref="UploadSelector" :referId='record.bidContractFiling.id'
                                        configKey='CONTRACT.FILING' :readonly="record.bidContractFiling && record.bidContractFiling.state=='1' "
                                        @uploadSuccess="uploadSelectorChange" />
            </div>
          </template>
        </a-table>
        <br>
        <span style="color: red;font-size: 14px;">注：如多个包组合并签署一份合同，也请按包组分别上传备查，谢谢合作！</span>
      </div>
      <div v-else>
        <div style="width:180px;margin:0 auto;">
          <img src="../../img/empty4.png" style="width:90px;margin: 0 auto;"/>
          <div style="text-align: center;" v-if="noContractFiling">无需合同备案</div>
          <div style="text-align: center;" v-if="noResultAnnounce">采购结果公告未发布</div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import PreCaseUploadSelector from './PreCaseUploadSelector'
import qs from 'qs'

const uuidv4 = require('uuid/v4')
export default {
  components: {
    PreCaseUploadSelector
  },
  props: {
    projectId: {
      type: String,
      required: true
    },
    random: {
      type: String,
      default: '',
      required: false
    }
  },
  created() {
    this.loadTableData();
  },
  watch: {
    random: {
      immediate: false,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadTableData();
        }
      }
    }
  },
  name: "PreCase",
  data() {
    return {
      bidObject: {},
      noResultAnnounce: false,//没有发布结果公告
      noContractFiling: false,
      isPayVisible: false,
      tableLoading: false,
      columns: [
        {
          title: '包组编号',
          dataIndex: 'pack_code',
        },
        {
          title: '包组名称',
          dataIndex: 'pack_name'
        },
        {
          title: '合同上传',
          width: '50%',
          scopedSlots: {customRender: 'operationSlot'}
        }
      ],
      loadData: [],
      bondList: [],
      current: 1,
      pageList: []
    }
  },

  mounted() {
  },
  methods: {
    //加载table的数据
    loadTableData() {
      let that = this;
      this.tableLoading = true;
      this.loadData = [];
      this.isPayVisible = false;
      this.noContractFiling = false;
      this.noResultAnnounce = false;
      this.$http.get('/api/v1/supplier/fee/getJjJgAnnounceList.json?projectId=' + that.projectId).then(function (res) {
        if (res.code != 200) {
          return
        }
        ;
        that.ResultInfo = res.result;
        if (res.result.length > 0) {
          let flag = true;
          for (let i = 0; i < res.result.length; i++) {
            if (res.result[i].announceType == '3') {
              flag = false;
              break;
            }
          }
          if (flag) {
            that.noResultAnnounce = true;
            return;
          }
          ;
          that.$http.get('/api/v1/supplier/packs/getWinTheBidBySupplierIdAndProjectId.json?projectId=' + that.projectId).then(function (response) {
            that.tableLoading = false;
            if (response.code == 200) {
              if (response.result.length == 0) {
                that.noContractFiling = true;
              } else {
                for (let i = 0; i < response.result.length; i++) {
                  if (response.result[i].is_pay && response.result[i].is_pay == '1') {
                    that.isPayVisible = true;
                  }
                  if (response.result[i].extras && response.result[i].extras.bidContractFiling) {

                  } else {
                    response.result[i].bidContractFilingId = uuidv4();
                  }
                }
                that.loadData = response.result;
              }
            }
          })
        } else {
          that.noResultAnnounce = true;
        }
      })
    },
    clearHtBaInfo(id) {
      this.$http.post('/api/v1/supplier/contract/filing/clear_bidContract_filing.json', qs.stringify({id: id})).then(function (res) {
        console.log("清除合同备案成功")
      })
    },
    uploadSelectorChange(fileLength,id) {
      if (fileLength) {
        const user = this.$ls.get('user');
        let projectName = this.ResultInfo[0].projectName;
        if (projectName && user.supplierName) {
          let title = "项目消息";
          let content = user.supplierName + "已上传了" + projectName + "的合同，请注意查看。";
          this.$http.get('/api/v1/supplier/bid/send_msg_in_project.json?id=' + this.projectId + '&title=' + title + '&content=' + content).then(function (res) {

          })
        }
      }else {
        //如果删除了合同备案附件 则也一并清除备案信息
        this.clearHtBaInfo(id)
      }
    }
  }
}
</script>

<style scoped>

</style>
